module.exports = __webpack_public_path__ + "img/game03.6e7a2f2d.png";